import {
  ADD_QUESTION,
  ADD_QUESTION_SUCCESS,
  ADD_QUESTION_CLEAN,
  ADD_QUESTION_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  question: undefined,
}

const QuestionAdd = (state = initialState, action) => {
  switch (action.type) {
    case ADD_QUESTION:
      state = {
        ...state,
        loading: true,
      }
      break
    case ADD_QUESTION_SUCCESS:
      state = {
        ...state,
        question: action.payload.question,
        loading: false,
        done: true,
      }
      break
    case ADD_QUESTION_CLEAN:
      state = initialState
      break
    case ADD_QUESTION_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default QuestionAdd
